module.exports = __webpack_public_path__ + "img/7.7734cb8d.jpg";